import React from 'react';
import { Menu, X, InstagramIcon, FacebookIcon } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/ukiyo.tours/",
  facebook: "https://www.facebook.com/ukiyojourneys",
  whatsapp: "https://api.whatsapp.com/send?phone=91859172501&text=Hi%20Ukiyo%20Tours%2C%20I%20want%20to%20plan%20a%20trip"
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const navigateToPage = (path) => {
    navigate(path);
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const handleWhatsAppClick = () => {
    window.open(SOCIAL_LINKS.whatsapp, '_blank', 'noopener,noreferrer');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/98 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">

          {/* Logo */}
          <div className="flex items-center cursor-pointer py-4" onClick={() => navigateToPage('/')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_64492122-1ef3-4521-a66d-df97c836c1aa/artifacts/fa6ost47_Ukiyo_Logo.png" 
              alt="Ukiyo Tours" 
              className="h-28 md:h-32 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">

            <button onClick={() => scrollToSection('destinations')} className="text-[#0B1F3A] hover:text-[#B8964F] font-medium">
              Destinations
            </button>

            <button onClick={() => scrollToSection('featured-package')} className="text-[#0B1F3A] hover:text-[#B8964F] font-medium">
              Packages
            </button>

            <button onClick={() => navigateToPage('/our-story')} className="text-[#0B1F3A] hover:text-[#B8964F] font-medium">
              Our Story
            </button>

            <button onClick={() => scrollToSection('contact')} className="text-[#0B1F3A] hover:text-[#B8964F] font-medium">
              Contact
            </button>

            {/* Social Icons */}
            <div className="flex items-center space-x-4 ml-4">
              <a 
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0B1F3A] hover:text-[#B8964F] transition-transform hover:scale-110"
              >
                <InstagramIcon size={20} strokeWidth={1.5} />
              </a>

              <a 
                href={SOCIAL_LINKS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0B1F3A] hover:text-[#B8964F] transition-transform hover:scale-110"
              >
                <FacebookIcon size={20} strokeWidth={1.5} />
              </a>
            </div>

            <Button 
              onClick={handleWhatsAppClick}
              className="bg-[#B8964F] hover:bg-[#a67f3a] text-white px-6 py-2 rounded-lg shadow-lg"
            >
              Plan on WhatsApp
            </Button>

          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden">
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>

        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-gray-100">

            <button onClick={() => scrollToSection('destinations')} className="block w-full text-left">
              Destinations
            </button>

            <button onClick={() => scrollToSection('featured-package')} className="block w-full text-left">
              Packages
            </button>

            <button onClick={() => navigateToPage('/our-story')} className="block w-full text-left">
              Our Story
            </button>

            <button onClick={() => scrollToSection('contact')} className="block w-full text-left">
              Contact
            </button>

            {/* Mobile Social Icons */}
            <div className="flex space-x-4 pt-2">
              <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer">
                <InstagramIcon size={22} />
              </a>
              <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer">
                <FacebookIcon size={22} />
              </a>
            </div>

            <Button onClick={handleWhatsAppClick} className="w-full bg-[#B8964F] text-white py-3">
              Chat on WhatsApp
            </Button>

          </div>
        )}
      </div>
    </header>
  );
};

export default Header;